export default __webpack_public_path__ + "static/media/certificate00.3a69598d.png";